import { createSlice } from '@reduxjs/toolkit';

export type SearchState = {
    didPerformSearch: boolean;
};

export const searchSlice = createSlice({
    name: 'search',
    initialState: {
        didPerformSearch: false,
    },
    reducers: {
        setDidPerformSearch: (state, action) => {
            state.didPerformSearch = action.payload;
        },
    },
});

export const { setDidPerformSearch } = searchSlice.actions;

export default searchSlice.reducer;
